"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiRoutes = void 0;
var urlcat_1 = __importDefault(require("urlcat"));
function route(path) {
    return function (basePath, params) { return (0, urlcat_1.default)("".concat(basePath || '').concat(path), params || {}); };
}
exports.apiRoutes = {
    createBor: route('/bor/create'),
    createHistoricalPolicy: route('/create-historical-policy'),
    setPolicyPriorTerm: route('/set-policy-prior-term'),
    setPolicyNextTerm: route('/set-policy-next-term'),
    endPolicy: route('/end-policy'),
    generateConversionAcord: route('/conversion/acords'),
    generateConversionAcord50: route('/conversion/acord50'),
    generateConversionAcord130: route('/api/acord-service/v1/acord130'),
    getAccountBORLinks: route('/accounts/bor-links'),
    getAccountBORs: route('/accounts/bors'),
    getAccountManagers: route("/account-managers"),
    getClient: route('/clients'),
    getClientPolicies: route('/clients/policies'),
    getClientServiceAssociates: route('/client-service-associates'),
    getCoverageTypes: route('/coverage-types'),
    getCoverageTypesNames: route('/coverage-types-names'),
    getEmployee: route('/employees'),
    getInsuranceProviders: route("/insurance-providers"),
    getNaics: route('/naics'),
    getNamedInsuredByUuid: route('/get-named-insured'),
    getNamedInsuredsByClientUuid: route('/get-named-insureds'),
    getPolicyChange: route('/get-policy-change'),
    getPolicyTerms: route("/policy-terms"),
    getProducers: route("/producers"),
    getProducerBORs: route('/admin/bors'),
    getQuoteUuidMapBySalesforceId: route('/admin/translate-bors'),
    getWritingCompanies: route("/writing-companies"),
    policyChange: route('/end-policy-change'),
    policyChanges: route('/policy-changes'),
    removePolicyChange: route('/remove-policy-change'),
    renewPolicyAsIs: route('/renew-policy-as-is'),
    sendBorTransferEmail: route('/clients/send-bor-transfer-email'),
    signBorLetters: route('/bor/sign-bor-letters'),
    updateBor: route('/bor/update'),
    updatePolicyChange: route('/update-policy-change'),
};
